import Vue from 'vue';
import './bootstrap/index';
import store from './store/index';
import router from './router/index';
import i18n from './i18n/index';
import 'theme/design.scss';
import 'theme/base.scss';
import AppLayout from 'modules/core/components/AppLayout.vue';
import environment, { updateEnvironment } from '@/environment';
import VueGtm from 'vue-gtm';
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

Vue.config.productionTip = false;

fetch('/portal/api/v1.0/PortalSettings')
  .then((response) => response.json())
  .then((json) => {
    updateEnvironment(json.Result);
    new Vue({
      store,
      router,
      i18n,
      render: (h) => h(AppLayout),
    }).$mount('#app');

    const appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.instrumentationKey,
        autoTrackPageVisitTime: true,
        enableAutoRouteTracking: true
      }
    });

    appInsights.loadAppInsights();

    appInsights.trackEvent({ name: 'App Loaded!' })

    Vue.use(VueGtm, {
      id: environment.gtmCode,
      enabled: true,
      debug: (environment.mode !== 'production'),
      loadScript: true,
      vueRouter: router,
    });
  });
